// extracted by mini-css-extract-plugin
module.exports = {"loading":"App--loading--1C37c"};